import { render, staticRenderFns } from "./SH060ShopperInfoConfirmError.vue?vue&type=template&id=7d2f7b30&"
import script from "./SH060ShopperInfoConfirmError.vue?vue&type=script&lang=js&"
export * from "./SH060ShopperInfoConfirmError.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports